import React, { useMemo } from 'react';
import { AccessorKeyColumnDef, createColumnHelper, RowData } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import Table from './Table';

export type DationInstanceDataEntry = {
	name: string;
	id: number;
};
const columnHelper = createColumnHelper<DationInstanceDataEntry>();

type Props = {
	dationInstances: DationInstanceDataEntry[];
	handleRowClick: (row: RowData) => void;
};
const DationInstanceOverview = ({ dationInstances, handleRowClick }: Props) => {
	const { t } = useTranslation();

	const columns = useMemo(
		() =>
			[
				columnHelper.accessor('name', {
					header: t('dation_instance.name'),
				}),
			] as Array<AccessorKeyColumnDef<DationInstanceDataEntry, unknown>>,
		[],
	);

	return <Table data={dationInstances} columns={columns} handleRowClick={handleRowClick} />;
};

export default DationInstanceOverview;
